// RoomFacilitesList.jsx
import React, { useEffect, useState } from "react";
import api from "../../../../../api/axios";
import BackButton from "../BackButton";

import AddFacilites from "./Components/AddFacilites";
import EditFacilites from "./Components/EditFacilites";
import RoomFacilitesTable from "./Components/RoomFacilitesTable";

const RoomFacilitesList = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState(null);

  const fetchFacilities = async () => {
    try {
      const res = await api.get("/pms/amenities");
      setFacilities(res.data || []);
    } catch (err) {
      console.error("Failed to fetch facilities:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete facility?")) return;
    await api.delete(`/pms/amenities/${id}`);
    fetchFacilities();
  };

  const openEdit = (facility) => {
    setSelectedFacility(facility);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room Type List</h3>
            <div className="col-auto d-flex w-sm-100">
              <button
                className="btn btn-dark"
                onClick={() => setIsAddOpen(true)}
              >
                Add Facility
              </button>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <RoomFacilitesTable
              data={facilities}
              loading={loading}
              onEdit={openEdit}
              onDelete={handleDelete}
            />
          </div>
        </div>

        <AddFacilites
          open={isAddOpen}
          onClose={() => setIsAddOpen(false)}
          onAdded={fetchFacilities}
        />

        <EditFacilites
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          facility={selectedFacility}
          onUpdated={fetchFacilities}
        />
      </div>
    </div>
  );
};

export default RoomFacilitesList;
